module.exports = __webpack_public_path__ + "img/yellow-icon-en(2).bf56e93a.png";